import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__nav" };
const _hoisted_3 = ["title"];
const _hoisted_4 = {
    key: 0,
    class: "data-item__topic"
};
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__content" };
const _hoisted_7 = { class: "data-item__section" };
const _hoisted_8 = { class: "data-item__section-title" };
const _hoisted_9 = {
    key: 0,
    class: "product__options"
};
const _hoisted_10 = { class: "product__article-actions" };
const _hoisted_11 = ["text"];
const _hoisted_12 = ["text"];
const _hoisted_13 = ["text"];
import { onMounted, onUnmounted, ref, watch, inject } from 'vue';
import { useRoute, useRouter } from "vue-router";
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import env from "../services/AppEnv";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import AddCartItems from "../commands/AddCartItems";
import AddWatchlistItems from "../commands/AddWatchlistItems";
import ProductArticleRow from "../components/ProductArticleRow.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import userSettings, {} from '@astina/paloma-common-ui/src/services/UserSettings';
import LoginOrRequestAccess from "../components/LoginOrRequestAccess.vue";
import portalConfig from "../services/PortalConfig";
import ProductArticlesMatrix from "../components/ProductArticlesMatrix.vue";
import { useUnavailabilityReason } from "../services/UnavailabilityReason";
import trans from '@astina/paloma-common-ui/src/services/Translator';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductView',
    emits: [
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const emit = __emit;
        const settings = userSettings('paloma-ui.portal.products');
        const catalogUiSettings = inject('catalogUiSettings');
        const product = ref(null);
        const mainCategory = ref(null);
        const options = ref(null);
        const optionsMatrix = ref(null);
        const addCartItems = ref(null);
        const addWatchlistItems = ref(null);
        const itemDrafts = ref([]);
        const user = ref(env.user);
        const error = ref(false);
        const userSettingsValue = ref(null);
        const { getUnavailabilityReason } = useUnavailabilityReason();
        onMounted(() => {
            loadProduct()
                .then(() => {
                // redirect to first variant?
                if (portalConfig.productDetails.redirectToFirstVariant
                    && (product.value?.variants || []).length > 1) {
                    onVariantSelect(product.value.variants[0]);
                }
            });
            userSettingsValue.value = settings.get({ expanded: false });
            events.$on('command.add_cart_items.success', resetItemDrafts);
        });
        onUnmounted(() => {
            events.$off('command.add_cart_items.success', resetItemDrafts);
        });
        watch(() => route.params, reset);
        function reset() {
            RouterUtils.singleParam(route, 'id') !== product.value?.itemNumber && loadProduct();
        }
        function loadProduct() {
            product.value = null;
            error.value = false;
            const itemNumber = RouterUtils.singleParam(route, 'id');
            return productRepository
                .get(itemNumber)
                .then(initProduct)
                .catch(() => error.value = true);
        }
        function onVariantSelect(variant) {
            // single-variant products have a special view
            if (product.value.variants.length <= 1) {
                return;
            }
            router.push({ name: 'catalog_category_product_variant', params: { sku: variant.sku } }).catch(() => {
            });
        }
        function onCartInputChange(draft) {
            const existing = itemDrafts.value.find(d => d.sku === draft.sku);
            if (existing === undefined) {
                if (draft.quantity > 0) {
                    itemDrafts.value.push(draft);
                }
            }
            else if (draft.quantity <= 0) {
                itemDrafts.value.splice(itemDrafts.value.indexOf(existing, 1));
            }
            else {
                existing.quantity = draft.quantity;
                existing.unit = draft.unit;
                existing.portions = draft.portions;
            }
        }
        function onSubmitFromArticlesMatrix() {
            if (itemDrafts.value.length === 0) {
                return;
            }
            addCartItems.value?.enqueue();
        }
        function initProduct(newProduct) {
            product.value = newProduct;
            mainCategory.value = newProduct.categories.length === 0 ? null : newProduct.categories[0];
            const optionsLocal = product.value.options || {};
            options.value = Object.keys(optionsLocal).length === 0 ? null : optionsLocal;
            optionsMatrix.value = ProductUtils.createOptionsMatrix(portalConfig.productOptionsMatrices, newProduct);
            resetItemDrafts();
            RouterUtils.setPageTitle(`${product.value.name} (${product.value.itemNumber})`);
            events.$emit('track.view_item', { product: newProduct });
        }
        function resetItemDrafts() {
            itemDrafts.value = [];
            if (isAvailableForPurchase()) {
                addCartItems.value = new AddCartItems(itemDrafts.value);
            }
            else {
                addCartItems.value = null;
            }
            addWatchlistItems.value = new AddWatchlistItems(itemDrafts.value);
            // If there is only one variant, we prepare an item draft
            if (product.value?.variants.length === 1) {
                const variant = product.value.variants[0];
                if (variant.availability && variant.availability.available && variant.price) {
                    onCartInputChange({
                        sku: variant.sku,
                        quantity: 1,
                        unit: variant.price.unitCode,
                    });
                }
            }
        }
        function isAvailableForPurchase() {
            return hasAvailableVariants() && hasVariantsWithOrderingUnits();
        }
        function hasAvailableVariants() {
            if (!product.value) {
                return false;
            }
            for (let i in product.value.variants) {
                if (product.value.variants[i].availability.available) {
                    return true;
                }
            }
            return false;
        }
        function activeVariantIsAvailable() {
            if (!product.value) {
                return false;
            }
            // no variant selected - fallback
            if (!RouterUtils.singleParam(route, 'sku')) {
                return hasAvailableVariants();
            }
            for (let i in product.value.variants) {
                if (product.value.variants[i].sku === RouterUtils.singleParam(route, 'sku') && product.value.variants[i].availability.available) {
                    return true;
                }
            }
            return false;
        }
        function unavailabilityReason() {
            if (!product.value || !product.value.variants) {
                return trans("product.no_variants_available");
            }
            const variants = product.value.variants;
            const skuParam = RouterUtils.singleParam(route, "sku");
            const variant = variants.find((v) => v.sku === skuParam) ||
                (variants.length === 1 ? variants[0] : null);
            if (!variant || !variant.availability) {
                return trans("product.no_variants_available");
            }
            return getUnavailabilityReason(variant.availability);
        }
        function hasVariantsWithOrderingUnits() {
            if (!product.value) {
                return false;
            }
            for (let i in product.value.variants) {
                if (product.value.variants[i].orderingUnits.length > 0) {
                    return true;
                }
            }
            return false;
        }
        function findDefaultQuantity(variant) {
            if (product.value?.variants.length !== 1) {
                return 0;
            }
            const unit = variant.orderingUnits.find(ou => ou.unitCode === variant.baseOrderingUnit);
            return unit && parseFloat(unit.minimumQuantity || '1') || 1;
        }
        function toggleExpanded() {
            if (userSettingsValue.value) {
                userSettingsValue.value.expanded = !userSettingsValue.value.expanded;
                settings.set(userSettingsValue.value);
            }
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        function catalogCategoryParams() {
            const params = {};
            // for whatever reason, the router behaves differently for params { }
            //   and { category: undefined }. The latter will call the route with
            //   category '', which is different from undefined triggers a grid
            //   refresh.
            if (route.params.category) {
                params['category'] = route.params.category;
            }
            return params;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item product", { 'product--loading': !product.value, 'data-item--expanded': userSettingsValue.value && userSettingsValue.value.expanded }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_unref(catalogUiSettings).view == 'v1')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleExpanded()), ["prevent"])),
                                class: "data-item__nav-item data-item__expand",
                                title: _ctx.$t(userSettingsValue.value && userSettingsValue.value.expanded ? 'collapse' : 'expand'),
                                href: ""
                            }, [
                                _createVNode(Icon, {
                                    name: userSettingsValue.value && userSettingsValue.value.expanded ? 'compress' : 'expand'
                                }, null, 8, ["name"])
                            ], 8, _hoisted_3))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (_unref(catalogUiSettings).view == 'v1')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                                class: "data-item__nav-item",
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "angle-left" })
                            ]))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createVNode(_component_router_link, {
                            to: { name: 'catalog_category', params: catalogCategoryParams() },
                            class: "data-item__nav-item"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(Icon, { name: "times" })
                            ]),
                            _: 1
                        }, 8, ["to"]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (_unref(catalogUiSettings).view == 'v1')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                                class: "data-item__nav-item",
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "angle-right" })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    (product.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (mainCategory.value)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(mainCategory.value.name), 1))
                                : _createCommentVNode("", true),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(product.value.name), 1)
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !product.value && !error.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    (error.value)
                        ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                        : _createCommentVNode("", true),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    (product.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("section", _hoisted_7, [
                                _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('product.articles')), 1),
                                _cache[16] || (_cache[16] = _createTextVNode()),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["product__variants-holder", { 'product__variants-holder--single-variant': product.value.variants.length === 1, 'product__variants-holder--with-options': options.value }])
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["product__variants", { 'product__variants--with-options': options.value }])
                                    }, [
                                        (optionsMatrix.value && product.value.variants.length > 1)
                                            ? (_openBlock(), _createBlock(ProductArticlesMatrix, {
                                                key: 0,
                                                matrix: optionsMatrix.value,
                                                variants: product.value.variants,
                                                onCartInputChange: onCartInputChange,
                                                onSelectVariant: onVariantSelect,
                                                onSubmit: onSubmitFromArticlesMatrix
                                            }, null, 8, ["matrix", "variants"]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (options.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "product__variants-sku-header" }, null, -1)),
                                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, type) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: type,
                                                                class: "product__option"
                                                            }, _toDisplayString(option.option), 1));
                                                        }), 128)),
                                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "product__variants-form-header" }, null, -1))
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _cache[12] || (_cache[12] = _createTextVNode()),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.variants, (variant) => {
                                                    return (_openBlock(), _createBlock(ProductArticleRow, {
                                                        key: variant.sku,
                                                        variant: variant,
                                                        options: options.value,
                                                        "initial-quantity": findDefaultQuantity(variant),
                                                        "mark-selected": product.value.variants.length > 1,
                                                        onCartInputChange: onCartInputChange,
                                                        onSelect: onVariantSelect,
                                                        onInputFocus: ($event) => (onVariantSelect(variant))
                                                    }, null, 8, ["variant", "options", "initial-quantity", "mark-selected", "onInputFocus"]));
                                                }), 128))
                                            ], 64))
                                    ], 2)
                                ], 2),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, [
                                    (!activeVariantIsAvailable())
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "login-required",
                                            text: unavailabilityReason()
                                        }, [
                                            _createTextVNode(_toDisplayString(unavailabilityReason()) + " ", 1),
                                            (!user.value.authenticated)
                                                ? (_openBlock(), _createBlock(LoginOrRequestAccess, { key: 0 }))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_11))
                                        : (!hasVariantsWithOrderingUnits())
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "login-required",
                                                text: _ctx.$t('product.no_variants_with_ordering_units')
                                            }, [
                                                _createTextVNode(_toDisplayString(_ctx.$t('product.no_variants_with_ordering_units')) + " ", 1),
                                                (!user.value.authenticated)
                                                    ? (_openBlock(), _createBlock(LoginOrRequestAccess, { key: 0 }))
                                                    : _createCommentVNode("", true)
                                            ], 8, _hoisted_12))
                                            : _createCommentVNode("", true),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    (!user.value.authenticated && isAvailableForPurchase())
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "login-required",
                                            text: _ctx.$t('login.required.for-checkout')
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('login.required.for-checkout')) + " ", 1),
                                            _createVNode(LoginOrRequestAccess)
                                        ], 8, _hoisted_13))
                                        : _createCommentVNode("", true),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_WATCHLISTS_MANAGE') && addWatchlistItems.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 3,
                                            command: addWatchlistItems.value,
                                            disabled: itemDrafts.value.length === 0,
                                            label: _ctx.$t('product.add_to_watchlist'),
                                            classes: ['button', 'button--outline'],
                                            class: "product__article-action--watchlist"
                                        }, null, 8, ["command", "disabled", "label"]))
                                        : _createCommentVNode("", true),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_ORDERS_CREATE') && addCartItems.value && isAvailableForPurchase())
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 4,
                                            command: addCartItems.value,
                                            disabled: itemDrafts.value.length === 0,
                                            label: _ctx.$t('product.add_to_order'),
                                            class: "product__article-action--cart"
                                        }, null, 8, ["command", "disabled", "label"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _cache[18] || (_cache[18] = _createTextVNode()),
                            _createVNode(_component_router_view, { product: product.value }, null, 8, ["product"])
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
